import React, { createContext } from 'react';
import AuthSystem from '../AuthenticationSystem/AuthSystem';


export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
    const allContexts = AuthSystem();
    return (
        <AuthContext.Provider value={allContexts}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;